import { http } from "@/http";

export default {
  listActive() {
    return http.get("/api/v1/admin/reference/active");
  },
};
